/**
 * tracking-common.js
 */

import { differenceInMilliseconds } from 'date-fns';
import { 
  DISTANCE_UNIT_NAME, 
  getCalculatedSpeedMS, 
  getDistanceFromLatLonM,
  convertDistance,
} from 'utils/distance';
import { formatSecondsAsTime } from 'utils/datetime';


export const API_KEY = 'AIzaSyD536oWTGqf8DeH0iNCn190KqVYRegP9Vs';
export const TRACK_STORAGE_KEY = 'trackContextData';
export const TRACKING_STORAGE_KEY = 'trackingContextData';
export const TRACKING_FORM_STORAGE_KEY = 'trackingFormContextData';


export const TRACKING_STATE = {
  UNSTARTED: 'unstarted',
  ACTIVE: 'active',
  STOPPED: 'stopped'
};


export const TRACK_COMPLETION_ACTION = {
  SAVE: 'save',
  COMPLETE: 'complete',
  DISCARD: 'discard'
};


export const TRACK_TYPE = {
  DEPLOYMENT: 'deployment',
  MULTI_DEPLOYMENT: 'multi-deployment',
  LEAD: 'lead',
  FOLLOW: 'follow'
};


export const TRACK_TYPE_LABEL = {
  [TRACK_TYPE.DEPLOYMENT]: 'Deployment Track',
  [TRACK_TYPE.LEAD]: 'Layer Track',
  [TRACK_TYPE.FOLLOW]: 'Follower Track',
  [TRACK_TYPE.MULTI_DEPLOYMENT]: 'Deployment Track',
};


export const TRACK_TYPE_ICON = {
  [TRACK_TYPE.DEPLOYMENT]: 'track-deployment',
  [TRACK_TYPE.LEAD]: 'track-lead',
  [TRACK_TYPE.FOLLOW]: 'track-follow',
  [TRACK_TYPE.MULTI_DEPLOYMENT]: 'track-deployment',
};


// calculates custom point properties and returns new object with original and new props.
// NOTE: prevPoint point must be previously processed and containing valid custom properties.
export const calculateCustomPointProperties = (firstPoint, prevPoint, point) => {
  if (!prevPoint) {
    return {
      ...point,
      speedCalculated: point.speed,
      elapsedSeconds: 0,
      elapsedTime: '0:00',
      distanceMeters: 0,
      distanceMetersRounded: 0,
      distanceYards: 0,
    };
  } else {
    const elapsedSeconds = Math.round(differenceInMilliseconds(point.dateTimeCreated, firstPoint.dateTimeCreated) / 1000 * 10) / 10
    const distanceM = prevPoint.distanceMeters + getDistanceFromLatLonM(prevPoint.latitude, prevPoint.longitude, point.latitude, point.longitude);
    return {
      ...point,
      speedCalculated: getCalculatedSpeedMS(prevPoint, point),
      elapsedSeconds: elapsedSeconds,
      elapsedTime: formatSecondsAsTime(elapsedSeconds),
      distanceMeters: distanceM,
      distanceMetersRounded: Math.round(distanceM),
      distanceYards: Math.round(convertDistance(distanceM, DISTANCE_UNIT_NAME.METERS, DISTANCE_UNIT_NAME.YARDS)) 
    };
  }
}


// process points, adding calculated properties
export const processPoints = (points) => {
  const firstPoint = points[0];
  let prevPoint = null;
  return points.map((point, i) => {
    const newPoint = calculateCustomPointProperties(firstPoint, prevPoint, point);
    prevPoint = newPoint;
    return newPoint;
  })
}


// distance analytics label
export const getDistanceAnalyticsLabel = (distanceMeters) => {
  const distanceYards = Math.round(convertDistance(distanceMeters, DISTANCE_UNIT_NAME.METERS, DISTANCE_UNIT_NAME.YARDS));
  if (distanceYards <= 30) {
    return `0-30`;
  } else if (distanceYards <= 100) {
    return '31-100';
  } else if (distanceYards <= 300) {
    return '101-300';
  } else if (distanceYards <= 800) {
    return '301-800';
  } else if (distanceYards <= 2000) {
    return '801-2k';
  } else if (distanceYards <= 5000) {
    return '2k-5k';
  } else {
    return '5k+';
  }
}


// duration analytics label
export const getDurationAnalyticsLabel = (durationSeconds) => {
  const durationMinutes = Math.round(durationSeconds / 60);
  if (durationMinutes <= 2) {
    return `0-2`;
  } else if (durationMinutes <= 5) {
    return '3-5';
  } else if (durationMinutes <= 10) {
    return '6-10';
  } else if (durationMinutes <= 20) {
    return '11-20';
  } else if (durationMinutes <= 40) {
    return '21-40';
  } else {
    return '41+';
  }    
}